import React from "react";

import ParkaPrimoInnenjacke from "../Garments/ParkaPrimoInnenjacke";

export default function ParkaPrimoInnenjackePage() {
  return <ParkaPrimoInnenjacke />;
}
